<template>
  <div class="dialogWrap">
    <div>
      <vue-qr v-if="url" class="qrStyle" :text="url" style="display: block;" :margin="0"/>
      <p v-else class="noDataStyle">加载中</p>
      <div class="dialog-footer">
        {{ content }}
      </div>
    </div>
  </div>
</template>
<script>
import VueQr from 'vue-qr'
export default {
  name: 'QrDialog',
  components: {
    VueQr
  },
  props: ['title', 'url', 'content'],
  data() {
    return {
      dialogVisible: false
    }
  },
  methods: {
    showDialog() {
      this.dialogVisible = true
    }
  }
}
</script>
<style lang="scss" scoped>
.dialogWrap {
  img {
    width: 270px;
    height: 270px;
    margin: 49px auto 39px;
  }
  .dialog-footer {
    text-align: center;
    font-family: Source Han Sans SC;
    font-weight: 400;
    font-size: 20px;
    color: #333333;
  }
  .noDataStyle{
    text-align: center;
    width: 100%;
    height: 200px;
    line-height: 200px;
    font-size: 24px;
    color: #333;
  }
}
</style>
